import * as React from "react";

const ContentSvg = ({ className }) => (
    <svg
        xmlns="http://www.w3.org/2000/svg"
        className={className}
        fill="none"
        viewBox="0 0 22 13"
    >
        <path
            d="M22 0v2.445H4.889V0zm0 4.89v2.444H4.889V4.889zm0 4.888v2.445H4.889V9.778zM1.222 0q.52 0 .871.352.351.351.351.87 0 .52-.35.871a1.18 1.18 0 0 1-.872.352q-.519 0-.87-.352A1.18 1.18 0 0 1 0 1.223q0-.52.351-.871Q.703 0 1.222 0m0 4.89q.52 0 .871.35.351.352.351.872 0 .519-.35.87a1.18 1.18 0 0 1-.872.352q-.519 0-.87-.352A1.18 1.18 0 0 1 0 6.112q0-.52.351-.871.352-.352.871-.352m0 4.888q.52 0 .871.352.351.351.351.87 0 .52-.35.871a1.18 1.18 0 0 1-.872.352q-.519 0-.87-.352a1.18 1.18 0 0 1-.352-.87q0-.52.351-.871.352-.352.871-.352"
        ></path>
    </svg>
);

export default ContentSvg;
